import { Stack } from '@mui/material'
import TreatmentPage from 'components/cattles/treatmentPage/TreatmentPage'

const TreatmentCard = () => {
	return (
		<Stack direction='column' gap='16px'>
			<TreatmentPage />
		</Stack>
	)
}

export default TreatmentCard
